// Client-approved default wording for the Short / Full description fields of the event form.
// Set A suits any social gathering; Set B is used when "This is a wedding" is on.
// Placeholders: {invitedBy}, {groom}, {bride}.

const TEMPLATES = {
  general: {
    short: {
      ar: "بدعوة كريمة من {invitedBy}، نتشرف بحضوركم.",
      en: "By kind invitation of {invitedBy}. We'd be honored by your presence.",
    },
    full: {
      ar: "يسرنا دعوتكم لمشاركتنا هذه المناسبة السعيدة. نتطلع لقضاء أوقات ممتعة ومليئة بالفرح برفقتكم، فحضوركم يزيدها بهجة وتميزاً.",
      en: "We're delighted to invite you to share this happy occasion with us. We look forward to a joyful time in your company. Your presence makes it brighter and more special.",
    },
  },
  wedding: {
    short: {
      ar: "{invitedBy} يتشرف بدعوتكم لحضور حفل زفاف {groom} و{bride}.",
      en: "{invitedBy} invites you to the wedding of {groom} & {bride}.",
    },
    full: {
      ar: "بدعوة كريمة من {invitedBy}، نتشرف بحضوركم حفل زفاف {groom} و{bride}، ونسعد بمشاركتكم هذه الفرحة.",
      en: "At the kind invitation of {invitedBy}, we'd be honored by your presence at the wedding of {groom} & {bride}, and happy to share this joy with you.",
    },
  },
  // Used for a wedding until the bride and groom names are typed.
  weddingNoNames: {
    short: {
      ar: "ندعوكم لمشاركتنا فرحة العمر في ليلة لا تُنسى.",
      en: "Join us in the joy of a lifetime on an unforgettable night.",
    },
    full: {
      ar: "بكل الحب والامتنان، ندعوكم لمشاركتنا فرحتنا. نرجو تأكيد حضوركم لنفرح معاً بهذه المناسبة السعيدة.",
      en: "With love and gratitude, we invite you to share our happiness. Please confirm your attendance so we can celebrate together.",
    },
  },
};

const FALLBACK_INVITED_BY = { ar: "العائلة", en: "The Family" };

// kind: "short" | "full"; lang: "ar" | "en".
export const getDefaultDescription = ({ kind, lang, isWedding, invitedBy, groom, bride }) => {
  const invited = (invitedBy || "").trim() || FALLBACK_INVITED_BY[lang];
  const groomName = (groom || "").trim();
  const brideName = (bride || "").trim();

  let set = TEMPLATES.general;
  if (isWedding) set = groomName && brideName ? TEMPLATES.wedding : TEMPLATES.weddingNoNames;

  return set[kind][lang]
    .replace("{invitedBy}", invited)
    .replace("{groom}", groomName)
    .replace("{bride}", brideName);
};
